export const MODAL_PAGE_DEFAULT_PERCENT_HEIGHT = 75;

export const PERCENT_OPENED = 0;
export const PERCENT_CLOSED = 100;
